<form [formGroup]="formGroup" (ngSubmit)="submit()" class="form-group entry-form" autocomplete="off">
    <box>
        <box class="preview-header">
            <h4>File preview</h4>
        </box>

        <box class="doc-img-preview-wrapper">
            <ng-container *ngFor="let file of state.files; let i = index">
                <box class="file">
                    <img class="file-preview" width='100%' height='100%' [src]="_helper.dom.bypassSecurityTrustUrl(file.imageSrc)" alt="document-front-preview"/>
                    <box class="file-details">
                            <span class="file-name">{{ file.name }}</span>
                            <box class="file-icons">
                                <img src="./assets/images/icons/download.svg" alt="Preview" (click)="_helper.previewFile(i)" />
                                <img src="./assets/images/icons/delete.svg" alt="Delete" (click)="_helper.onDelete(i)" />
                            </box>
                    </box>
                </box>
                
            </ng-container>
        </box>
    </box>
    
</form>